import axios from 'axios';

import version  from "../package.json";
import config from "./configSingleton";

if(Object.keys(config).length === 0){
    await config.saveConfig();
}

const cancelToken = axios.CancelToken.source();

const instance = axios.create({
    baseURL: config.backendApi
});

instance.interceptors.request.use(request => {

    if (request.url !== "users/v1/login" && !localStorage.getItem("TOKEN")) {

        throw new axios.cancel("NO_TOKEN")

        return window.location.replace("/login");
    }

    request.headers['x-access-token'] = localStorage.getItem("TOKEN");
    request.headers['x-version-control'] = version.version;

    if (request.url.includes(":getGeolocation")) {
        request.baseURL = config.geolocationAPI;
        request.url = request.url.replace("/:getGeolocation", "");

        return request;
    }


    return request;
}, error => {
    return Promise.reject(error);
})


// instance.interceptors.response.use(response => {
//     return response;
// }, error => {
//     console.log(error);
//     const {key} = error.response.data;

//     if (key === "TOKEN_EXPIRED") {
//         return window.location.replace("#/login")
//     }

//     return Promise.reject(error);
// })

export default instance;
